module.exports = __webpack_public_path__ + "img/logo.c2298736.svg";